import "./css/main.css";
import "./js/components/a11y";
import "./js/components/accordion";
import "./js/components/swiper";
import "./js/components/dialog";
import "./js/components/drawer";
import "./js/components/modal";
import "liquid-ajax-cart";
import "./js/components/facets";
import "./js/components/ajaxinate";
import "./js/snippets/product-card";
import "./js/snippets/localization-form";
import "./js/components/search";
import "./js/components/selling-plan";
import "./js/components/quick-order";
import "./js/components/reveal-on-scroll";
import "./js/components/shop-the-look";
import "./js/templates/header";
import "./js/templates/cart";
import "./js/sections/parallax";
import "./js/sections/cart";
import AOS from 'aos';
import { focusTrap } from "./js/helpers.js";

// Templates
import LoadSections from "./js/sections";

// Initialisation code
(() => {
  const Moonbase = window.Moonbase || {};
  console.log("🚀 Shopify Theme by Brave The Skies");
  document.documentElement.className =
    document.documentElement.className.replace("no-js", "js");


  // Listen for the "liquid-ajax-cart:request-end" event which is fired
  // after a Shopify Cart API Ajax request is performed
  let isMiniCartOpen = false;
  let miniCartTrap = null;
  let trappedMiniCartEl = null;

  const applyMiniCartOpenState = () => {
    const miniCart = document.getElementById("js-minicart");
    if (!miniCart) return;

    miniCart.setAttribute("aria-hidden", "false");
    miniCart.removeAttribute("inert");

    // Liquid Ajax Cart can replace the section DOM, so rebind trap if needed.
    if (trappedMiniCartEl !== miniCart) {
      miniCartTrap?.deactivate();
      miniCartTrap = focusTrap(miniCart);
      trappedMiniCartEl = miniCart;
    }

    miniCartTrap.activate();
  };

  const applyMiniCartClosedState = () => {
    const miniCart = document.getElementById("js-minicart");
    if (miniCart) {
      miniCart.setAttribute("aria-hidden", "true");
      miniCart.setAttribute("inert", "");
    }

    miniCartTrap?.deactivate();
    miniCartTrap = null;
    trappedMiniCartEl = null;
  };

  document.addEventListener("liquid-ajax-cart:request-end", (event) => {
    const { requestState } = event.detail;

    // If the "add to cart" request is successful
    if (requestState.requestType === "add" && requestState.responseData?.ok && !document.body.classList.contains("cart")) {
      document.body.classList.add("overlay--active");
      isMiniCartOpen = true;
    }

    // Re-apply open state after any cart re-render
    if (isMiniCartOpen) {
      applyMiniCartOpenState();
    }
  });
  window.Moonbase.setRecentlyViewedProducts = (productData) => {
    const productList = [];
    let jsonResp, jsonRespArr, jsonRespArrStr;
    productList.push(productData);
    const currProductPageTitle = productData.title;
    const productDataString = JSON.stringify(productList);
    const localData = localStorage.getItem("recentlyViewedProducts");
    if (localData === null) {
      localStorage.setItem("recentlyViewedProducts", productDataString);
    } else if (localData) {
      const oldProductData = localStorage.getItem("recentlyViewedProducts");
      const parsedOldProductData = JSON.parse(oldProductData);
      const sameProduct = oldProductData.includes(currProductPageTitle);
      if (sameProduct) {
        const index = parsedOldProductData.findIndex(
          (product) => product.title === currProductPageTitle
        );
        if (index !== -1) {
          parsedOldProductData[index] = productData;
          localStorage.setItem(
            "recentlyViewedProducts",
            JSON.stringify(parsedOldProductData)
          );
        }
      } else {
        jsonRespArr = parsedOldProductData.concat(productList);
        localStorage.setItem(
          "recentlyViewedProducts",
          JSON.stringify(jsonRespArr)
        );
      }
    }
  };

  // AOS - Animations On Scroll
  AOS.init();

  // Overlay
  const closeOverlayButtons = document.querySelectorAll(
    "[close-overlay-button]"
  );
  const closeOverlay = () => {
    document.body.classList.remove(Moonbase.classes.minicartOpen);
    isMiniCartOpen = false;
    applyMiniCartClosedState();
  };

  closeOverlayButtons.forEach((button) => {
    button.addEventListener("click", closeOverlay);
  });

  const overlay = document.querySelector(".site-overlay");
  overlay.addEventListener("click", () => {
    document.body.classList.remove(Moonbase.classes.filterDrawerOpen);
  });

  /* Initialise a global Moonbase variable
	 that can be accessed on the front end
	 if not already defined. */

  // used to dynamically load template & section js per page.
  // prevents loading js that isn't required
  // Add sections in theme-js.liquid:
  // Moonbase.sections = [
  //      ...
  //     'my-new-section'
  // ]
  LoadSections(Moonbase.sections)
    .then(() => {
      Moonbase.loaded = true;
      const evt = new CustomEvent("moonbase:loaded");
      console.log("Moonbase loaded");
      document.dispatchEvent(evt);
    })
    .catch((e) => console.log("Error loading template files", e));
})();
